import React, { Fragment, useState, useEffect } from 'react';
import { Polyline, OverlayView, Marker } from '@react-google-maps/api';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { Typography, Chip } from '@mui/material';
import {
    trackDetailViewSelector, visibleTracksSelector, highlightedDriveSelector,
    trackPlayerIndexSelector
} from '../../../features/datacenter/historySlice';
import { assetNamesSelector } from '../../../features/assets/assetsSlice';
import { use } from 'react';
const iconToolsColor = "Ivory";
//const activeIconToolsColor = "Tomato";

const options = {
    strokeColor: "red",
    strokeOpacity: 1,
    strokeWeight: 2,
    clickable: false,
    draggable: false,
    editable: false,
    geodesic: false,
    zIndex: 1
}


const TrackLine = ({ reportID }) => {


    const trackData = useSelector(state => state.history.trackData[reportID]);
    const visibleTracks = useSelector(visibleTracksSelector);
    const focussed = useSelector(trackDetailViewSelector) === reportID;
    const trackPlayerIndex = useSelector(trackPlayerIndexSelector);
    const highlightedDrive = useSelector(highlightedDriveSelector);
    const assetNames = useSelector(assetNamesSelector);
    const icon = assetNames && trackData && assetNames[trackData.reqBody.imei] && assetNames[trackData.reqBody.imei].icon;

    const visible = visibleTracks.indexOf(reportID) !== -1 || focussed;

    const stops = trackData && trackData.stops;
    const drives = trackData && trackData.drives;
    const events = [];
    if (drives && drives.length > 0) {
        drives.forEach(d => {
            if (d.events.length > 0) {
                d.events.forEach(e => events.push(e));
            }
        })
    }
    useEffect(() => {
        console.log("trackData changed", trackData);
    }, [trackData]);

    const stopmarks = [];
    let startFlag = true;
    let endFlag = true;
    if (stops && stops.length > 0) {
        stops.forEach((s, si) => {
            const oneDay = moment(s.stopStartTime).format('D/M/Y') === moment(s.stopEndTime).format('D/M/Y');
            const timeLabel = oneDay ?
                `${moment(s.stopStartTime).format('D/M/Y h:mm A')} to ${moment(s.stopEndTime).format('h:mm A')}`
                :
                `${moment(s.stopStartTime).format('D/M/Y h:mm A')} to ${moment(s.stopEndTime).format('D/M/Y h:mm A')}`
            const eventLabel = stops.events ? `Events: ${stops.events.length}` : '';
            const address = trackData.track[s.startIndex].address && trackData.track[s.startIndex].address.net_addr;
            const label = `${timeLabel} \n${eventLabel} \n${address}`;
            stopmarks.push({
                position: {
                    lat: trackData.track[s.startIndex].lat,
                    lng: trackData.track[s.startIndex].lng,
                },
                label,
                timeLabel,
                durationLabel: s.stopDuration,
                eventLabel,
                address,
                index: si
            })
        })
        startFlag = stops[0].startIndex !== 0;
        endFlag = stops[stops.length - 1].endIndex !== trackData.track.length - 1;
    }

    const eventmarks = [];
    if (events && events.length > 0) {
        events.forEach((e, ei) => {
            const timeLabel = moment(e.event_time).format('D/M/Y h:mm:ss a');
            const address = trackData.track[e.routeIndex].address && trackData.track[e.routeIndex].address.net_addr;
            eventmarks.push({
                position: {
                    lat: trackData.track[e.routeIndex].lat,
                    lng: trackData.track[e.routeIndex].lng,
                },
                timeLabel,
                address,
                eventLabel: `${e.event_type || e.event_desc} ${e.speed} Km/h`,
                index: ei
            })
        })
    }

    //console.log("track", trackData);
    const [showStopLabel, setshowStopLabel] = useState(null);
    const [showEventLabel, setShowEventLabel] = useState(null);

    if (trackData && trackData.track && trackData.track.length > 0 && window.google && visible) {
        const trackPath = trackData.track.map(t => ({ lat: t.lat, lng: t.lng }));
        const trackColor = trackData.trackColor;
        let highlightPath = null;
        if (focussed && highlightedDrive.startIndex && highlightedDrive.endIndex) {
            highlightPath = [];
            trackData.track.forEach((t, i) => {
                if (i >= highlightedDrive.startIndex && i <= highlightedDrive.endIndex) {
                    highlightPath.push({ lat: t.lat, lng: t.lng });
                }
            })
        }
        const lineSymbol = {
            path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
            fillColor: trackColor
        };
        return (

            <Fragment>
                {
                    focussed &&
                    <OverlayView
                        position={{
                            lat: trackData.track[trackPlayerIndex].lat,
                            lng: trackData.track[trackPlayerIndex].lng
                        }}
                        mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                    >
                        <Fragment>
                            <img
                                src={`/assets/markers/def30/${icon}`}
                                alt={trackData.assetName}
                                style={{
                                    transform: `rotate(${trackData.track[trackPlayerIndex].angle}deg)`,
                                    display: 'inline-block',
                                    position: 'absolute',
                                    left: -7,
                                    top: -15,
                                }}
                            />
                            <Chip
                                size="small"
                                style={{
                                    backgroundColor: trackData.track[trackPlayerIndex].speed < 30 ? '#3498DB' : trackData.track[trackPlayerIndex].speed < 60 ? '#27AE60' : '#E74C3C',
                                    position: 'absolute',
                                    left: -0,
                                    top: 20,
                                }}
                                label={
                                    <span style={{ color: "White" }}>
                                        {trackData.track[trackPlayerIndex].speed} Km/h
                                    </span>
                                }
                            />
                        </Fragment>

                    </OverlayView>
                }
                {
                    startFlag &&
                    <Marker
                        icon={`/assets/history/def20/mapmarkergreen.png`}
                        position={{
                            lat: trackData.track[0].lat,
                            lng: trackData.track[0].lng,
                        }}
                    />
                }
                {
                    endFlag &&
                    <Marker
                        icon={`/assets/history/def20/mapmarker.png`}
                        position={{
                            lat: trackData.track[trackData.track.length - 1].lat,
                            lng: trackData.track[trackData.track.length - 1].lng,
                        }}
                    />
                }

                <Polyline
                    path={trackPath}
                    options={{
                        ...options,
                        strokeColor: 'tomato',
                        strokeWeight: focussed ? highlightPath ? 1 : 3 : 2,
                        strokeOpacity: focussed ? highlightPath ? 0.75 : 1 : 1,
                        icons: [
                            {
                                icon: lineSymbol,
                                offset: '25%'
                            },
                            {
                                icon: lineSymbol,
                                offset: '50%'
                            },
                            {
                                icon: lineSymbol,
                                offset: '75%'
                            },
                        ]
                    }}
                />
                {
                    highlightPath && highlightPath.length > 0 &&
                    <Polyline
                        path={highlightPath}
                        options={{
                            ...options,
                            strokeColor: 'crimson',
                            strokeWeight: 4,
                            strokeOpacity: 1,
                            icons: [
                                {
                                    icon: lineSymbol,
                                    offset: '33%'
                                },
                                {
                                    icon: lineSymbol,
                                    offset: '67%'
                                },
                            ]
                        }}
                    />
                }
                {
                    stopmarks.map((s, i) =>
                        <Fragment key={`${i}_stop`}>
                            <Marker
                                icon={showStopLabel === i ? `/assets/history/def40/parking.png` : `/assets/history/def20/parking.png`}
                                position={s.position}
                                onClick={() => setshowStopLabel(showStopLabel === i ? null : i)}

                            />
                            <OverlayView
                                position={s.position}
                                mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                            >

                                {
                                    showStopLabel === i ?
                                        <div style={{
                                            backgroundColor: iconToolsColor,
                                            position: 'absolute',
                                            left: 10,
                                            top: -10,
                                            width: '200px',
                                            borderRadius: '3px',
                                        }}>
                                            <div style={{ margin: '5px' }}>
                                                <Typography variant="body1">
                                                    <b>Parking: {s.durationLabel}</b>
                                                </Typography>
                                                <Typography variant="subtitle1">
                                                    {s.timeLabel}
                                                </Typography>
                                                <Typography variant="subtitle2">
                                                    {s.eventLabel}
                                                </Typography>
                                                <Typography variant="caption">
                                                    {s.address}
                                                </Typography>
                                            </div>


                                        </div>
                                        : <p></p>
                                }


                            </OverlayView>
                        </Fragment>
                    )
                }
                {
                    eventmarks.map((s, i) =>
                        <Fragment key={`${i}_event`}>
                            <Marker
                                icon={showEventLabel === i ? `/assets/history/def40/event.png` : `/assets/history/def20/event.png`}
                                position={s.position}
                                onClick={() => setShowEventLabel(showEventLabel === i ? null : i)}

                            />
                            <OverlayView
                                position={s.position}
                                mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                            >

                                {
                                    showEventLabel === i ?
                                        <div style={{
                                            backgroundColor: iconToolsColor,
                                            position: 'absolute',
                                            left: 10,
                                            top: -10,
                                            width: '200px',
                                            borderRadius: '3px',
                                            margin: '5px',
                                        }}>
                                            <div style={{ margin: '5px' }}>
                                                <Typography variant="subtitle1">
                                                    <b>{s.eventLabel}</b>
                                                </Typography>
                                                <Typography variant="subtitle2">
                                                    {s.timeLabel}
                                                </Typography>
                                                <Typography variant="caption">
                                                    {s.address}
                                                </Typography>
                                            </div>
                                        </div>
                                        : <p></p>
                                }


                            </OverlayView>
                        </Fragment>
                    )
                }
            </Fragment>
        );
    } else {
        return null;
    }

}

export default TrackLine;

/**
<span style={{
    backgroundColor: iconToolsColor,
    position: 'absolute',
    left: 10,
    top: -10,
    width: '200px'
}}>
    <Typography variant="caption">
        {showStopLabel === i ? s.label : ""}
    </Typography>
</span>
 */